import React, { useState } from 'react';
import { useCinemas } from '../../hooks/useCinemas';
import { formatCinemaData } from '../../utils/mapUtils';

const MovieDetail = ({movie, onBack}) => {
    const { cinemas } = useCinemas();
    const [showFullDescription, setShowFullDescription] = useState(false);

    const toggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    };
    console.log(movie.showtimes);
    

    return (
        <div className="flex flex-col gap-4 pb-10">
            {/* Bandeau image et titre */}
            <div className="relative w-full h-40 shadow-lg rounded-xl overflow-hidden">
                <img
                    src={movie.poster || '/placeholder.jpg'} // image du film
                    alt={movie.title}
                    className="object-cover w-full h-full"
                />
                <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black via-black/60 to-transparent p-2 flex items-end">
                    <h5 className="text-xs font-semibold text-white text-left w-full leading-tight line-clamp-2">
                        {movie.title}
                    </h5>
                </div>
            </div>

            {/* Infos film */}
            <div className="px-2 text-sm text-gray-700 leading-snug">
                <p className="font-semibold">
                    De <span className="text-black">{movie.director.firstName} {movie.director.lastName}</span><br/>
                    Avec <span className="text-black">  {movie.actors.map((actor, index) => (
                        <span key={index} className="text-black">
                            {actor.firstName} {actor.lastName}
                            {index < movie.actors.length - 1 ? ', ' : ''}
                        </span>
                    ))}<br/></span>
                    Sortie le <span className="text-black">{movie.firstReleaseDate}</span><br/>
                    <span className="text-black">
                        {movie.genres.map((genre, index) => (
                            <span key={index} className="text-black">
                                {genre}
                                {index < movie.genres.length - 1 ? ', ' : ''}
                            </span>
                        ))}
                    </span> - {movie.duration}
                </p>
                <p className="mt-2 text-sm">
                    {!showFullDescription && movie.description.length > 140
                        ? movie.description.slice(0, 140) + '...'
                        : movie.description}
                    {movie.description.length > 140 && (
                        <button 
                            onClick={toggleDescription}
                            className="text-blue-500 font-semibold hover:text-blue-600"
                        >
                            {showFullDescription ? ' (voir moins)' : ' (voir plus)'}
                        </button>
                    )}
                </p>
            </div>

            {/* Horaires par cinéma */}
            <div className="flex flex-col gap-4 px-2">
                {Object.entries(movie.showtimes).map(([cinemaId, versions]) => {
                    const cinema = cinemas.find(c => c.allocine_id === cinemaId);
                    const formattedCinema = cinema ? formatCinemaData(cinema) : null;
                    const cinemaName = formattedCinema ? formattedCinema.name : cinemaId;
                    return (
                        <div key={cinemaId} className="bg-gray-100 rounded-xl p-3">
                            <div className="flex justify-between items-center mb-2">
                                <div className="font-semibold text-sm">{cinemaName}</div>
                                <div className="text-gray-400 text-sm">›</div>
                            </div>

                            {Object.entries(versions).map(([version, times]) =>
                                times.length > 0 ? (
                                    <div key={version} className="mb-2">
                                        <div className="text-xs font-medium text-gray-600 capitalize mb-1">
                                            {version === 'local' ? 'VF' :
                                             version === 'original' ? 'VOSTFR' :
                                             version === 'multiple' ? 'VF/VOSTFR' :
                                             version === 'dubbed' ? 'VF' :
                                             version}
                                        </div>
                                        {Object.entries(
                                            times.reduce((acc, timeObj) => {
                                                const date = timeObj.date;
                                                if (!acc[date]) {
                                                    acc[date] = [];
                                                }
                                                acc[date].push(timeObj);
                                                return acc;
                                            }, {})
                                        ).map(([date, dateTimes]) => (
                                            <div key={date} className="mb-2">
                                                <div className="text-xs font-medium text-gray-500 mb-1">
                                                    {new Date(date).toLocaleDateString('fr-FR', { 
                                                        weekday: 'long',
                                                        day: 'numeric',
                                                        month: 'long'
                                                    })}
                                                </div>
                                                <div className="flex flex-wrap gap-2">
                                                    {dateTimes.map((timeObj, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="bg-white border border-gray-300 rounded px-3 py-1 text-xs font-medium"
                                                        >
                                                            {timeObj.time}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : null
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MovieDetail;
